import type { ReportType } from './reportTypes'
import { REPORT_TYPES } from './reportTypes'

export interface CustomField {
	name: string
	values: string[]
}

export const isReportAvailable = (report: ReportType, customFieldsData?: CustomField[]): boolean => {
	if (!report.requiresCustomField) return true
	if (!customFieldsData) return false

	const requiredField = report.requiresCustomField.toLowerCase()
	const isAvailable = customFieldsData.some((field) => field.name.toLowerCase() === requiredField)

	return isAvailable
}

export const getVisibleReports = (reports: ReportType[], disabledReportIds: string[] = []): ReportType[] => {
	return reports.filter((r) => !disabledReportIds.includes(r.id))
}

export const formatCycleOptions = (cycles: Array<{ id: string; cycleInfo: { name?: string; status: string } }>) => {
	return cycles.map((c) => ({
		value: c.id,
		label: `${c.cycleInfo.name || 'Cycle'} (${c.cycleInfo.status})`,
	}))
}

export const canExecuteReport = (
	reportId: string,
	selectedCycleId: string,
	customFieldsData?: CustomField[],
): { canExecute: boolean; reason?: string } => {
	if (!selectedCycleId) {
		return { canExecute: false, reason: 'Please select a cycle' }
	}

	const report = Object.values(REPORT_TYPES)
		.flat()
		.find((r) => r.id === reportId)
	if (!report) {
		return { canExecute: false, reason: 'Report not found' }
	}

	if (!isReportAvailable(report, customFieldsData)) {
		return { canExecute: false, reason: `Requires '${report.requiresCustomField}' custom field` }
	}

	return { canExecute: true }
}
